export const Symbols = {
  ENVIRONMENT: Symbol.for('ENVIRONMENT'),
  ERROR_MONITORING: Symbol.for('ERROR_MONITORING'),
}
